// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3A6Al","toggleWrap":"styles_toggleWrap__1ayQ4","content":"styles_content__2H4-i","selectAreaCode":"styles_selectAreaCode__1B63v"};